import React, { useEffect } from "react";
import { useLocation } from "@reach/router";

import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";

import { StaticImage } from "gatsby-plugin-image";

import HeaderTypography from "./Typography/HeaderTypography";
import ParagraphTypography from "./Typography/ParagraphTypography";
import WhiteButton from "./WhightButton";
import NotFoundPage from "../../pages/404";

import requestDemoBGImg from "../../images/v2/case-studies/requestDemo.svg";
import featureBG from "../../images/v2/case-studies/featuresBG.svg";

import useWidth from "../../hooks/useWidth";

import { Link } from "gatsby";

import case1hero from "../../images/v2/case-studies/case-1.webp";
import case2hero from "../../images/v2/case-studies/suprime-bg.webp";
import case3hero from "../../images/v2/case-studies/dreamcation-bg.webp";
import case4hero from "../../images/v2/case-studies/case-4-hero.png";
import case5hero from "../../images/v2/case-studies/tech-data-bg.webp";
import condoWongHero from "../../images/v2/case-studies/congo-wong-bg.webp";
import mazeedHero from "../../images/v2/case-studies/case-7.webp";
import case8name from "../../images/v2/case-studies/case-8-name.webp";
import condoWongName from "../../images/v2/case-studies/case-6-name.webp";
import case1name from "../../images/v2/case-studies/case-1-name.webp";
import case2name from "../../images/v2/case-studies/case-5-name.webp";
import case3name from "../../images/v2/case-studies/case-3-name.webp";
import case4name from "../../images/v2/case-studies/case-4-name.png";
import case5name from "../../images/v2/case-studies/case-4-name.webp";
import case6name from "../../images/v2/case-studies/case-2-name.webp";

import access from "../../images/v2/case-studies/Access.svg";
import calendar from "../../images/v2/case-studies/Calendar.svg";
import dashboard from "../../images/v2/case-studies/Dashboard.svg";
import enterprise from "../../images/v2/case-studies/Enterprise.svg";
import lead from "../../images/v2/case-studies/Lead.svg";
import message from "../../images/v2/case-studies/Message.svg";
import messenger from "../../images/v2/case-studies/Messenger.svg";
import pipeline from "../../images/v2/case-studies/Pipeline.svg";
import webform from "../../images/v2/case-studies/Webforms.svg";
import whatsapp from "../../images/v2/case-studies/Whatsapp.svg";
import xero from "../../images/v2/case-studies/Xero.svg";
import feature1 from "../../images/v2/case-studies/feature1.svg";
import feature2 from "../../images/v2/case-studies/feature2.svg";
import feature3 from "../../images/v2/case-studies/feature3.svg";
import feature4 from "../../images/v2/case-studies/feature4.svg";
import feature5 from "../../images/v2/case-studies/feature5.svg";
import feature6 from "../../images/v2/case-studies/feature6.svg";
import feature7 from "../../images/v2/case-studies/feature7.svg";
import feature8 from "../../images/v2/case-studies/feature8.svg";
import feature9 from "../../images/v2/case-studies/feature9.svg";
import feature10 from "../../images/v2/case-studies/feature10.svg";
import feature11 from "../../images/v2/case-studies/feature11.svg";
import feature12 from "../../images/v2/case-studies/feature12.svg";
import feature13 from "../../images/v2/case-studies/feature13.svg";
import feature14 from "../../images/v2/case-studies/feature14.svg";
import feature15 from "../../images/v2/case-studies/feature15.svg";
import feature16 from "../../images/v2/case-studies/feature16.svg";
import feature17 from "../../images/v2/case-studies/feature17.svg";
import feature18 from "../../images/v2/case-studies/feature18.svg";
import feature19 from "../../images/v2/case-studies/feature19.svg";
import RoomOutlined from "@material-ui/icons/RoomOutlined";
import BusinessOutlined from "@material-ui/icons/BusinessOutlined";
import LanguageOutlined from "@material-ui/icons/LanguageOutlined";
import ArrowForwardIos from "@material-ui/icons/ArrowForwardIos";

import SEO from "../SEO";
import zIndex from "@material-ui/core/styles/zIndex";
import { motion } from "framer-motion";

const useStyles = makeStyles((theme) => ({
   requestDemoRoot: {
      background: `url(${requestDemoBGImg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
   },
   featureBG: {
      background: `url(${featureBG})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
   },
   img: {
      maxWidth: "100%",
      height: "auto",
   },
   logo: {
      width: "54px",
      height: "54px",
   },
   featureItem: {
      borderLeft: "1px solid",
      borderRadius: theme.shape.borderRadius * 2.5,
      borderColor: "#e2f0ff",
      padding: theme.spacing(4),
      [theme.breakpoints.down("sm")]: {
         borderLeft: "unset",
      },
   },
   listItem: {
      marginBottom: "10px",
   },
   aboutList: {
      position: "sticky",
      top: "80px",
      display: "flex",
      justifyContent: "row",
   },
   aboutListIndicator: {
      background: "#FF8B3D",
      width: "3px",
      height: "100px",
      borderRadius: "4px",
      "&:after": {
         content: '""',
         top: "20px",
         width: "2px",
         marginLeft: "0.5px",
         zIndex: -1,
         height: "500px",
         position: "absolute",
         background: "#EDF1F6",
      },
   },
   readMoreLink: {
      color: "#FF8B3D",
      textDecoration: "underline",
      fontSize: "16px",
      fontWeight: 600,
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      "&:hover": { color: "#cc6a20" },
   },
   storyCard: {
      background: "white",
      borderRadius: "16px",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      boxShadow: "0 0px 20px rgba(0,0,0,0.18)",
      padding: "16px",
      gap: "12px",
      height: "100%",
   },
   storyCardImg: {
      width: "100%",
      height: "200px",
      objectFit: "cover",
      display: "block",
      borderRadius: "16px",
   },
   storyCardLogo: {
      height: "36px !important",
      width: "auto !important",
      alignSelf: "flex-start",
   },
   companyLogo: {
      height: "auto !important",
      width: "90% !important",
   },
   heroSection: {
      paddingTop: "80px",
      background:
         "radial-gradient(circle at 10% 10%, rgba(255, 163, 101, 0.35) 0%, transparent 30%), radial-gradient(circle at 50% 10%, rgba(158, 90, 213, 0.35) 0%, transparent 40%),radial-gradient(circle at 90% 10%, rgba(159, 211, 255, 0.6) 0%, transparent 35%), transparent",
      [theme.breakpoints.down("sm")]: {
         paddingTop: "0px",
      },
   },
   locationTag: {
      border: "1.5px solid #208EEC",
      borderRadius: "50px",
      padding: "8px 20px",
      fontSize: "14px",
      marginRight: theme.spacing(1.5),
      display: "inline-block",
      color: "#208EEC",
      background: "white",
      fontWeight: 500,
   },
   industryTag: {
      border: "1.5px solid #FF8B3D",
      borderRadius: "50px",
      padding: "8px 20px",
      fontSize: "14px",
      display: "inline-block",
      color: "#FF8B3D",
      background: "white",
      fontWeight: 500,
   },
   heroCard: {
      borderRadius: "32px",
      overflow: "hidden",
      position: "relative",
      minHeight: "480px",
      width: "100%",

      [theme.breakpoints.down("sm")]: {
         minHeight: "700px", // taller wrapper for image + content
      },
   },

   // Background image
   heroCardBgImg: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "72%",
      height: "100%",
      objectFit: "cover",
      display: "block",

      [theme.breakpoints.down("sm")]: {
         width: "100%",
         height: "50%",
      },
   },

   // Gradient overlay layer
   heroCardContent: {
      position: "absolute",
      top: 0,
      right: 0,
      width: "80%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingLeft:'25%',

      // stronger visible desktop gradient
      background:
         " linear-gradient(90deg,rgba(0, 34, 64, 0) 0%, rgba(0, 34, 64, 0.61) 34%, rgba(0, 34, 64, 0.81) 42%, rgba(0, 34, 64, 0.93) 49%, rgba(0, 34, 64, 1) 56%)",
      [theme.breakpoints.down("sm")]: {
         top: "auto", // important
         bottom: 0,
         left: 0,
         width: "100%",
         height: "80%",

         alignItems: "flex-end",
         justifyContent: "flex-end",
 paddingLeft:'0',
         background: `
      linear-gradient(180deg,rgba(0, 34, 64, 0) 1%, rgba(0, 34, 64, 0.61) 12%, rgba(0, 34, 64, 0.88) 20%, rgba(0, 34, 64, 1) 25%)
   `,
      },
   },

   // Right side content
   heroCardPanel: {
      width: "70%",
      padding: theme.spacing(4),
      position: "relative",
      zIndex: 2,

      [theme.breakpoints.down("sm")]: {
         width: "100%",
         padding: theme.spacing(2.5),
      },
   },
   featureIconCircle: {
      width: "44px",
      height: "44px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: theme.spacing(1),
      flexShrink: 0,
   },
   sidebarMeta: {
      display: "flex",
      alignItems: "flex-start",
      marginBottom: theme.spacing(3),
   },
   sidebarMetaIcon: {
      fontSize: "18px",
      color: "#708093",
      marginRight: theme.spacing(1),
      marginTop: "2px",
      flexShrink: 0,
   },
   sidebarMetaLabel: {
      fontSize: "16px",
      color: "#708093",
      fontWeight: 600,
      margin: 0,
      marginBottom: "2px",
   },
   sidebarMetaValue: {
      fontSize: "15px",
      color: "#1f2937",
      margin: 0,
      lineHeight: 1.4,
   },
   heroHeading: {
      fontSize: "56px !important",
      "@media(max-width:1024px)": {
         fontSize: "48px !important",
      },
      "@media(max-width:600px)": {
         fontSize: "34px !important",
      },
   },
   sectionHeading: {
      fontSize: "48px",
      fontWeight: 600,
      color: "#111827",
      margin: 0,
      marginBottom: theme.spacing(5),
      "@media(max-width:992px)": {
         fontSize: "40px",
      },
      "@media(max-width:600px)": {
         fontSize: "32px",
      },
   },
   sectionTitle: {
      fontWeight:'600',
      fontSize: "56px !important",
       "@media(max-width:1200px)": {
         fontSize: "48px",
      },
      "@media(max-width:992px)": {
         fontSize: "38px !important",
      },
      "@media(max-width:600px)": {
         fontSize: "32px !important",
      },
   },
   commonPageFooterSection: {
      background: "linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
      padding: "80px 0",
      "& .centerContainer": {
         display: "flex",
         flexDirection: "column",
         justifyContent: "center",
         alignItems: "center",
         gap: "32px",
         width: "80%",
         margin: "0 auto",
         textAlign: "center",
      },
      "@media only screen and (max-width: 600px)": {
         "& .centerContainer": {
            width: "100%",
         },
      },
   },
   quotationBlock: {
      background: "#F8FCFF",
      borderRadius: "12px",
      padding: '10px',
      color: "#1D6FB6",
      fontStyle: "italic",
      fontSize: "26px", 
      fontWeight: 400,
      margin: 0,
      marginBottom: theme.spacing(3),
      "& strong": {
         fontWeight: 400,
      },
      [theme.breakpoints.down("sm")]: {
         fontSize: "17px",
         padding: theme.spacing(2, 3),
      },
   },
}));

const Company = ({ pageContext }) => {
   const location = useLocation();

   const company = pageContext?.slug || location.pathname.split("/")[2];

   const classes = useStyles();
   const width = useWidth();

   const names = {
      "eng-choon-enterprise": (
         <img alt="Eng Choon Enterprise Pte. Ltd" src={case1name} className={classes.companyLogo} />
      ),
      "the-supreme": (
         <img alt="The Supreme HR Advisory Pte. Ltd." src={case2name} className={classes.companyLogo} />
      ),
      dreamcation: (
         <img alt="Dreamcation" src={case3name} className={classes.companyLogo} />
      ),
      "skypac-packaging": (
         <img alt="SKYPAC Packaging Pte. Ltd." src={case4name} className={classes.companyLogo} />
      ),
      "tech-data": (
         <img alt="Tech Data" src={case5name} className={classes.companyLogo} />
      ),
      cuscapi: (
         <img alt="Cuscapi" src={case6name} className={classes.companyLogo} />
      ),
      "condo-wong": (
         <img alt="Condo Wong" src={condoWongName} className={classes.companyLogo} />
      ),
      mazeede: (
         <img alt="Mazeed" src={case8name} className={classes.companyLogo} />
      ),
   };

   const titles = {
      "eng-choon-enterprise":
         "Eng Choon Enterprises is connecting with its customers across various channels",
      "the-supreme": "The Supreme HR Advisory is closing more leads faster",
      dreamcation:
         "Dreamcation is reducing its response time with Pepper Cloud CRM",
      "skypac-packaging": "Pepper Cloud CRM helps SKYPAC scale up its business",
      "tech-data":
         "Tech Data is managing leads and sales effectively with Pepper Cloud CRM",
      cuscapi:
         "Cuscapi is formulating its sales growth with Pepper Cloud sales CRM",
      "condo-wong":
         "Condo Wong is managing its real estate inquiries with Pepper Cloud AI WhatsApp CRM",
      mazeede:
         "Mazeed is centralising communication and streamlining support with Pepper Cloud CRM",
   };

   const successStories = {
      "eng-choon-enterprise": {
         nameImg: case1name,
         nameAlt: "Eng Choon Enterprise Pte. Ltd",
         title: titles["eng-choon-enterprise"],
         link: "/crm-case-studies/eng-choon-enterprise/",
         heroBg: case1hero,
      },
      "the-supreme": {
         nameImg: case2name,
         nameAlt: "The Supreme HR Advisory Pte. Ltd.",
         title: titles["the-supreme"],
         link: "/crm-case-studies/the-supreme/",
         heroBg: case2hero,
      },
      dreamcation: {
         nameImg: case3name,
         nameAlt: "Dreamcation",
         title: titles["dreamcation"],
         link: "/crm-case-studies/dreamcation/",
         heroBg: case3hero,
      },
      "skypac-packaging": {
         nameImg: case4name,
         nameAlt: "SKYPAC Packaging Pte. Ltd.",
         title: titles["skypac-packaging"],
         link: "/crm-case-studies/skypac-packaging/",
         heroBg: case4hero,
      },
      "tech-data": {
         nameImg: case5name,
         nameAlt: "Tech Data",
         title: titles["tech-data"],
         link: "/crm-case-studies/tech-data",
         heroBg: case5hero,
      },
      cuscapi: {
         nameImg: case6name,
         nameAlt: "Cuscapi",
         title: titles["cuscapi"],
         link: "/crm-case-studies/cuscapi",
         heroBg: case1hero,
      },
      "condo-wong": {
         nameImg: condoWongName,
         nameAlt: "Condo Wong",
         title: titles["condo-wong"],
         link: "/crm-case-studies/condo-wong/",
         heroBg: condoWongHero,
      },
      mazeede: {
         nameImg: case8name,
         nameAlt: "Mazeed",
         title: titles["mazeede"],
         link: "/crm-case-studies/mazeede",
         heroBg: mazeedHero,
      },
   };

   const caseStudies = {
      "eng-choon-enterprise": {
         seo: {
            title: "Omnichannel CRM Case Study - Eng Choon | Pepper Cloud",
            keywords:
               "WhatsApp CRM Case Studies,WhatsApp CRM, Message management, CRM Case Studies",
            description:
               "Eng Choon Enterprises uses Pepper Cloud WhatsApp CRM to answer chats directly inside the system, use fast message templates, and stop switching between apps.",
         },
         title: titles["eng-choon-enterprise"],
         description:
            "Eng Choon Enterprise Pte. Ltd. (a.k.a. Aircon Uncle) is a B2C organisation that offers sales and installation of new aircon units, aircon servicing, and maintenance. It was incorporated in 2013 and has been a one-stop solution for all air quality needs since then.",
         heroBg: case1hero,
         alt: "Eng Choon Enterprise Pte. Ltd.",
         name: names["eng-choon-enterprise"],
         location: "Singapore",
         industry: "Cleaning services",
         website: "https://www.airconuncle.sg/",
         challenges: [
            "Aircon Uncle receives hundreds of queries and messages from its prospects and customers. The messages would be received through multiple communication channels such as Facebook, WhatsApp, etc. This meant that the sales, operation, and support teams had to respond to messages across various channels.",
            "The hassle of replying to messages across multiple platforms led to confusion within the team, delayed follow-ups during the critical stages of the sales process, a lack of transparency and visibility among the team members, and loss of sales opportunities.",
            "To resolve these issues and to prevent potential customers getting lost, Aircon Uncle needed a robust CRM that integrates with various channels and helps in effectively managing the sales conversations. ",
         ],
         challegeQuotation: (
            <strong>
               "We needed a dynamic tool that helps manage customer queries
               efficiently"
            </strong>
         ),
         solutionHeader:
            "Pepper Cloud CRM, being a WhatsApp CRM, eased the entire workflow for Aircon Uncle while reducing the turnover time drastically.",
         solutions: [
            "WhatsApp-integrated Pepper Cloud CRM allowed the team to respond to messages from within the CRM, without switching between apps.",
            "The team could reply on time with personalised, error-free message templates with the help of WhatsApp CRM. This helped the team to keep the conversation going and ensure no opportunities were missed.",
            "The management team gained complete visibility into the enquiries and could monitor the conversations between the leads and the team. This helped in redirecting the sales activities and training the personnel appropriately.",
            "The team members could assign the conversations to the other members. The easy assignment of messages between teams offered better collaboration between the sales, operations, and support teams.",
         ],
         solutionQuotation: (
            <strong>
               "We are now able to convert leads faster and reduce drop-offs"
            </strong>
         ),
         solutionFooter: "",
         featuresUsed: [
            {
               icon: feature1,
               title: "WhatsApp integration",
               link: "/whatsapp-crm/",
            },
            { icon: feature2, title: "Message management", link: "" },
            {
               icon: feature3,
               title: "Quotation management",
               link: "/crm-integrations/xero-accounting-software/",
            },
         ],
         similarSuccessStories: [
            successStories["the-supreme"],
            successStories["dreamcation"],
            successStories["mazeede"],
         ],
      },
      "the-supreme": {
         seo: {
            title: "CRM for Staffing Industry Case Study - Supreme HR | Pepper Cloud",
            description:
               "The Supreme HR Advisory closes leads faster using Pepper Cloud CRM. Office 365 and Outlook integrations keep emails, calendars, and sales files synced in one place.",
            keywords:
               "Sales Pipeline Management Case Studies,sales pipeline, Sales CRM, CRM Case Studies",
         },
         title: titles["the-supreme"],
         description:
            "The Supreme HR Advisory Pte. Ltd. is a recruitment agency that provides an efficient, effective and enjoyable staffing experience to job-seekers and employers since 2014.",
         heroBg: case2hero,
         alt: "The Supreme HR Advisory",
         name: names["the-supreme"],
         location: "Singapore",
         industry: "Recruitment agency",
         website: "https://www.thesupremehr.com/",
         challenges: [
            "The Supreme HR Advisory was able to generate leads easily. However, the team collected lead details in multiple spreadsheets and it was difficult to keep these spreadsheets updated all the time. It was confusing, hard to access and different versions of spreadsheets would pile up on the shared devices. This made the whole process cumbersome. As a result, there were delayed follow-ups and loss of opportunities and the process of tracking the team performance became time-consuming and tedious. The team soon realised their requirement.",
            "The Supreme HR Advisory needed a sales CRM solution that integrates with emails and is simple and easy to use for their salespeople.",
         ],
         challegeQuotation: (
            <strong>
               "We needed a sales-focused CRM that helps our business grow"
            </strong>
         ),
         solutionHeader:
            "Pepper Cloud CRM helped The Supreme HR Advisory in solving their problems by providing them with a single comprehensive platform.",
         solutions: [
            "Pepper Cloud CRM made it easier for the company to document their leads and sales data effortlessly at one easily accessible, central location. Furthermore, move the leads forward through the sales pipeline without any hassle.",
            <div>
               With{" "}
               <Link to="/crm-email-inbox-integration/">
                  CRM Office 365 integration
               </Link>
               , the emails could synchronise two-way and the emails could be
               sent and viewed directly from Pepper Cloud CRM.
            </div>,
            "Calendar and drive management became easier with CRM Outlook integration.",
            "Pepper Cloud CRM provided a complete overview of the leads in the sales pipeline and the status of the sales deals. The easy access to key information boosted the sales productivity of the team.",
            "The reporting and real-time dashboards of the CRM allowed the managers to stay up to date with what their team is working on, without constantly chasing for updates.",
            "The Supreme HR Advisory wanted to onboard every member of the organisation to use the CRM solution without increasing the monthly recurring cost. Our Enterprise plan helped them to achieve this.",
         ],
         solutionQuotation: (
            <strong>
               "The user interface is easy and our sales process is now more
               organised"
            </strong>
         ),
         solutionFooter: "",
         featuresUsed: [
            {
               icon: feature8,
               title: "Sales pipeline management",
               link: "/sales-pipeline-management-tool/",
            },
            {
               icon: feature9,
               title: "Enterprise plan",
               link: "/crm-platfrom-pricing/",
            },
            {
               icon: feature10,
               title: "Office 365 integration",
               link: "/crm-email-inbox-integration/",
            },
         ],
         similarSuccessStories: [
            successStories["dreamcation"],
            successStories["condo-wong"],
            successStories["tech-data"],
         ],
      },
      dreamcation: {
         seo: {
            title: "Travel CRM & Response Time Case Study - Dreamcation | Pepper Cloud",
            description:
               "Dreamcation cut query response times by connecting Facebook to Pepper Cloud CRM. Leads are captured instantly, auto-replied to, and logged in one spot for quick follow-ups.",
            keywords:
               "Facebook Messenger Integration Case Studies,Facebook messenger integration, CRM Case Studies",
         },
         title: titles["dreamcation"],
         description:
            "Dreamcation Cruises and Tours is a leisure travel agency in Singapore that provides halal tours for those who love to explore. The services include tours, cruises, free and easy, MICE and incentive, as well as private tours.",
         heroBg: case3hero,
         alt: "Dreamcation",
         name: names["dreamcation"],
         location: "Singapore",
         industry: "Travel agency",
         website: "https://www.dreamcation.com.sg/",
         challenges: [
            "Dreamcation used to receive a vast number of queries through Facebook and they struggled to respond to all the queries on time. As a result, many leads and opportunities slipped away. Additionally, Dreamcation had no single point of access to manage its deliverables, sales data, leads, and other key details. The bits of information were scattered across multiple platforms. The lack of cohesion and visibility affected efficiency and productivity. These made it difficult to move leads through the pipeline resulting in the loss of deals and missed opportunities. It caused major disruption in sales growth.",
            "Dreamcation started looking out for a Facebook CRM tool which is customisable and scalable solution. They needed a CRM for Facebook messenger that assists in consolidating the queries, reducing the response time, and capturing lead details effortlessly.",
         ],
         challegeQuotation: (
            <strong>
               "We took longer time to respond to queries and the leads would
               just get lost"
            </strong>
         ),
         solutionHeader:
            "Pepper Cloud, a best CRM for Facebook leads, was a perfect fit for the requirements of Dreamcation.",
         solutions: [
            "Dreamcation could integrate Pepper Cloud CRM with their Facebook channel and could attend to the queries and messages right from the CRM.",
            "Sales representatives were notified of messages instantly and were able to send preset automatic replies. This reduced the response time to a great extent.",
            "Pepper Cloud CRM could automatically capture the details of leads from Facebook and consolidate lead information for easy access and follow-ups.",
            "The conversations could be assigned to other team members as and when required. This feature allowed the team to collaborate more effectively.",
            "Pepper Cloud offered a central hub through which the management could track the sales activities; monitor and manage the goals and data; and realign the sales efforts whenever necessary.",
         ],
         solutionQuotation: (
            <strong>
               "Facebook integration helped us handle queries in the shortest
               period of time"
            </strong>
         ),
         solutionFooter:
            "The Facebook integrated CRM, Pepper Cloud, assisted Dreamcation extensively in responding to queries and not letting any of the opportunities slip through the cracks.",
         featuresUsed: [
            {
               icon: feature11,
               title: "Facebook messenger integration",
               link: "/sales-crm-features/multichannel-integration-for-sales-marketing/",
            },
            { icon: feature12, title: "Lead and contact management", link: "" },
            {
               icon: feature13,
               title: "Pipeline management",
               link: "/sales-pipeline-management-tool/",
            },
         ],
         similarSuccessStories: [
            successStories["condo-wong"],
            successStories["tech-data"],
            successStories["cuscapi"],
         ],
      },
      "skypac-packaging": {
         seo: {
            title: "CRM for the Packaging Industry Case Study- SKYPAC | Pepper Cloud",
            description:
               "SKYPAC eliminated manual data entry by connecting Pepper Cloud CRM with Xero. The 2-way sync auto-fetches contact details, automates quotes, and keeps customer data safe.",
            keywords:
               "Xero CRM Case Studies,Xero CRM integrations, CRM, CRM Case Studies",
         },
         title: titles["skypac-packaging"],
         description:
            "SKYPAC Packaging Pte. Ltd. offers quality packaging products at competitive prices to their customers. They envision being the preferred source of flexible packaging solutions in Singapore.",
         heroBg: case4hero,
         alt: "SKYPAC",
         name: names["skypac-packaging"],
         location: "Singapore",
         industry: "Packaging solutions",
         website: "https://www.skypacpackaging.com/",
         challenges: [
            "SKYPAC, a leading packaging solution company, was on a growth tangent and needed a powerful CRM solution that could help them scale up faster. They had a pipeline full of leads but they lacked coordination between sales, marketing, and accounting teams.",
            "Every time the sales team had to get information about the value of an account or had to generate sales quotations, they had to seek the assistance of the accounts department. The process was not systemised. As a result, the sales team didn’t have access to the required information at the right time to generate and send quotations, causing delays in closing deals.",
            "SKYPAC needed a comprehensive solution which could integrate with accounting software and is ancillary to its sales growth.",
         ],
         challegeQuotation: (
            <strong>
               "We needed a solution to help us streamline our sales process and
               increase work efficiency"
            </strong>
         ),
         solutionHeader:
            "After thorough research on various CRM solutions, SKYPAC invested in Pepper Cloud, a CRM software that integrates with Xero.",
         solutions: [
            "Pepper Cloud CRM offered a scalable and customised solution for all the challenges faced by SKYPAC.",
            "The CRM offered a single, central location to store the critical information and allowed the management to define who can access what data, with data permissions.",
            "With a centralised database, SKYPAC no longer has to worry about losing customer conversation data and other information while transferring the data from one platform to another.",
            "The actionable information about sales, leads, and activities that are displayed in visual dashboards made it easier to focus on team productivity and assisted in defining future sales goals.",
            "The Xero CRM integrations of Pepper Cloud assisted SKYPAC in generating, sending, and managing sales quotations effortlessly. Additionally, it also allowed the team to track the status of the sent quotations.",
            "The 2-way sync of this Xero CRM saved valuable time and efforts of the team by auto-fetching the details of customers and making the process of generating sales quotations a lot more easier.",
         ],
         solutionQuotation: (
            <strong>
               "Pepper Cloud is easy-to-use, flexible, and scalable CRM software
               that cuts down repetitive tasks and increases our work
               efficiency"
            </strong>
         ),
         solutionFooter: "",
         featuresUsed: [
            { icon: feature10, title: "Access controls", link: "" },
            {
               icon: feature11,
               title: "Dashboard",
               link: "/sales-dashboard/",
            },
            {
               icon: feature12,
               title: "Xero CRM integration",
               link: "/crm-integrations/xero-accounting-software/",
            },
         ],
         similarSuccessStories: [
            successStories["tech-data"],
            successStories["cuscapi"],
            successStories["eng-choon-enterprise"],
         ],
      },
      "tech-data": {
         seo: {
            title: "Lead & Sales Management CRM Case Study - Tech Data | Pepper Cloud",
            description:
               "Tech Data captures web leads automatically with Pepper Cloud CRM. Embedded forms, custom fields, and revenue forecasting tools keep their pipeline organized and predictable.",
            keywords:
               "Lead Management Case Studies,Lead management, CRM Case Studies",
         },
         title: titles["tech-data"],
         description:
            "Tech Data is an end-to-end technology distributor with a focus on customers’ needs and goals with the objectivity of a true strategic partner.",
         heroBg: case5hero,
         alt: "Tech Data",
         name: names["tech-data"],
         location: "Singapore, Malaysia",
         industry: "IT services",
         website: "https://www.techdata.com/",
         challenges: [
            "Before adopting Pepper Cloud CRM as the company’s CRM, Tech Data was using spreadsheets to manage its leads and customer data.  The manual error was a persistent problem. But alongside, it also resulted in delays in follow-ups and missing opportunities. The lack of visibility into the sales data and less collaboration with other departments led to a lack of resource management and reduced team productivity. Although there were lots of sales activities taking place, they needed a sales tool to define and drive goal-oriented sales activities.",
            "In essence, Tech Data was looking for a scalable, customisable, and the best CRM solution for its sales reps and for its rapidly expanding business.",
         ],
         challegeQuotation: (
            <strong>
               "Team collaboration, accurate sales forecasting, and effective
               resource management were the major challenges we encountered"
            </strong>
         ),
         solutionHeader:
            "With heavily integrated Pepper Cloud CRM, Tech Data could easily capture leads and manage its entire sales process effectively.",
         solutions: [
            <div>
               Tech Data started to automatically capture leads from multiple
               landing pages through the{" "}
               <Link to="/lead-capture-generation-webform/">
                  embedded web forms
               </Link>{" "}
               of Pepper Cloud CRM. The sales team would receive instant
               notifications about new leads. This reduced the response time and
               ensured no opportunities were missed.
            </div>,
            "The custom fields in Pepper Cloud CRM allowed the team to customise the business modules as per their requirements and eased the process of recording the data into the sales CRM.",
            "With end-to-end sales pipeline management, Tech Data could successfully organise, track, and streamline its sales process, and design sales strategy.",
            "With the sales CRM features like winning probability and weighted average, Tech data could accurately assess its financial health and predict future revenue.",
         ],
         solutionQuotation: (
            <strong>
               "Pepper Cloud enhanced our productivity, optimised the sales
               process and helped manage our sales pipeline"
            </strong>
         ),
         solutionFooter: "",
         featuresUsed: [
            {
               icon: feature14,
               title: "Mailchimp integration",
               link: "/integration",
            },
            {
               icon: feature15,
               title: "Web forms",
               link: "/lead-capture-generation-webform/",
            },
            { icon: feature16, title: "Lead management", link: "" },
         ],
         similarSuccessStories: [
            successStories["cuscapi"],
            successStories["eng-choon-enterprise"],
            successStories["the-supreme"],
         ],
      },
      cuscapi: {
         seo: {
            title: "Activity & Lead Management Case Studies - Cuscapi | Pepper Cloud",
            description:
               "Cuscapi streamlines sales with Pepper Cloud. They easily track pipelines, secure team access controls, and get actionable insights from a dashboard.",
            keywords:
               "Activity Management Case Studies,Activity management (calendar), Lead management, CRM Case Studies",
         },
         title: titles["cuscapi"],
         description:
            "Cuscapi offers business management solutions, information technology security solutions, consulting services and contact centre outsourcing services for businesses across various industries.",
         heroBg: case1hero,
         alt: "Cuscapi",
         name: names["cuscapi"],
         location: "Malaysia, Singapore",
         industry: "Management services",
         website: "https://cuscapi.com/",
         challegeQuotation: (
            <strong>
               "We needed a sales CRM to help us manage our business in 6
               countries"
            </strong>
         ),
         challenges: [
            "Cuscapi needed a scalable CRM that works shoulder-to-shoulder with it to structure sales strategy and monetise its sales across 6 countries. They couldn’t risk losing information and simultaneously, needed a clear overview of their leads and prospects.",
            "Cuscapi was using a spreadsheet model to manage leads and their customer data. With the team spread out across different countries, they struggled with next to no visibility between the teams and management. These issues resulted in coordination challenges, missed opportunities and slowed down the sales process.",
            "It was critical for Cuscapi to find an easy-to-use, cloud-based, and best sales pipeline management tool that formalises its sales structure, manages its business operations across various countries, yet provides the required information in real-time.",
         ],
         solutionHeader:
            "Cuscapi realised that Pepper Cloud CRM can be the solution for all the issues it was encountering in its day-to-day operations.",
         solutions: [
            "Pepper Cloud CRM provided a central location to store the lead details and customer data and empowered the team with easy access to the information.",
            "Cuscapi could define the data permissions for its team by defining the roles, profiles, and permissions for its users. This provides only required information to the sales representatives and yet protects the other data.",
            "After onboarding with Pepper Cloud CRM, Cuscapi created multiple sales pipelines, tailored to its requirements and structured a hassle-free sales funnel for its leads and opportunities. This helped in addressing the gaps in the sales process.",
            "The intuitive sales dashboard assist Cuscapi in analysing key performance metrics and gaining action-oriented insights for their sales plan.",
         ],
         solutionQuotation: (
            <strong>
               "The strong sales pipeline management and robust user management
               system help us to manage our business operations"
            </strong>
         ),
         solutionFooter: "",
         featuresUsed: [
            {
               icon: feature17,
               title: "Activity management (calendar)",
               link: "",
            },
            { icon: feature18, title: "Lead management", link: "" },
            {
               icon: feature19,
               title: "Custom sales pipeline",
               link: "/sales-pipeline-management-tool/",
            },
         ],
         similarSuccessStories: [
            successStories["eng-choon-enterprise"],
            successStories["the-supreme"],
            successStories["dreamcation"],
         ],
      },
      "condo-wong": {
         seo: {
            title: "Real Estate Lead Management Case Study - Condo Wong | Pepper Cloud",
            keywords:
               "WhatsApp CRM Case Study, Real Estate CRM, WhatsApp Sales CRM, CRM Case Studies",
            description:
               "Condo Wong manages all real estate inquiries using Pepper Cloud. Track pipelines, automate WhatsApp follow-ups, and capture every sales opportunity.",
         },
         title: titles["condo-wong"],
         description:
            "Condo Wong is a Toronto-based real estate company specialising in helping clients buy, sell, and invest in condominiums. Led by Director and CEO Dan Wong, the team operates across multiple digital channels to serve a growing client base.",
         heroBg: condoWongHero,
         alt: "Condo Wong",
         name: names["condo-wong"],
         location: "Toronto, Canada",
         industry: "Real Estate",
         website: "https://www.condowong.ca",
         challegeQuotation: (
            <>
               <span>
                  "Managing inquiries across multiple platforms without a
                  centralised system was slowing down sales and straining team
                  efficiency."
               </span>
               <br />
               <span >
                  – Dan Wong, Director, CEO
               </span>
            </>
         ),
         challenges: [
            "As their client base expanded and inquiries came in from multiple digital channels, Condo Wong needed a more efficient way to stay on top of lead communication, especially via WhatsApp, a platform heavily preferred by many of their clients. Managing all this manually was becoming unsustainable.",
            <div>
               <p style={{ margin: "0 0 8px" }}>
                  Without a centralised system, Condo Wong faced the following
                  challenges:
               </p>
               <ul style={{ margin: 0, paddingLeft: "20px" }}>
                  <li className={classes.listItem}>
                     <strong>Fragmented communication:</strong> Agents used
                     personal WhatsApp accounts for client communications,
                     making it difficult to track conversations centrally.
                  </li>
                  <li className={classes.listItem}>
                     <strong>Manual sales tracking:</strong> Without a
                     structured system, tracking deals and sales progress was
                     time-consuming and error-prone.
                  </li>
                  <li className={classes.listItem}>
                     <strong>Limited visibility:</strong> Management lacked
                     real-time insight into how agents were engaging with leads
                     and progressing deals.
                  </li>
               </ul>
            </div>,
            "It was clear they needed a scalable WhatsApp Sales CRM solution that could centralise communication and streamline sales tracking.",
         ],
         solutionHeader:
            "To tackle these challenges, Condo Wong implemented Pepper Cloud CRM with a strong focus on the following features:",
         solutionQuotation: (
            <span>
               "With Pepper Cloud AI WhatsApp CRM, Condo Wong centralised
               communication, streamlined sales tracking, and empowered their
               team with tools for automation and collaboration."
            </span>
         ),
         solutions: [
            <div>
               <strong>Centralised WhatsApp communication:</strong> All client
               chats from WhatsApp are funnelled into a shared CRM inbox,
               eliminating the need for agents to use personal devices and
               ensuring complete visibility across the team.
            </div>,
            <div>
               <strong>
                  Respond within the CRM using verified business number:
               </strong>{" "}
               Agents reply to WhatsApp messages directly from Pepper Cloud CRM
               using an official WhatsApp Business account, maintaining
               professionalism and consistency.
            </div>,
            <div>
               <strong>Seamless conversation continuity:</strong> With complete
               chat history stored in the CRM, agents can pick up conversations
               where others left off — no more lost context when teammates are
               unavailable.
            </div>,
            <div>
               <strong>End-to-end sales pipeline tracking:</strong> Every lead's
               journey — from first inquiry to closing — is mapped visually,
               giving agents and managers real-time insights into progress,
               delays, and next steps.
            </div>,
            <div>
               <strong>Automated follow-ups and task reminders:</strong> The
               team leverages workflow automation to stay on top of follow-ups,
               improving lead conversion and eliminating missed opportunities.
            </div>,
            <div>
               <strong>Clear lead assignment and ownership:</strong> Incoming
               leads and chats are assigned to specific agents, preventing
               overlap and improving accountability across the sales team.
            </div>,
            <div>
               <strong>Enhanced internal collaboration:</strong> Internal notes,
               tagging, and activity tracking allow seamless teamwork without
               disrupting the customer experience — keeping everyone aligned
               behind the scenes.
            </div>,
         ],
         solutionFooter: "",
         featuresUsed: [
            {
               icon: feature1,
               title: "WhatsApp integration",
               link: "/whatsapp-crm/",
            },
            {
               icon: feature4,
               title: "Sales pipeline management",
               link: "/sales-pipeline-management-tool/",
            },
            { icon: feature5, title: "Lead management", link: "" },
         ],
         similarSuccessStories: [
            successStories["eng-choon-enterprise"],
            successStories["the-supreme"],
            successStories["dreamcation"],
         ],
      },
      mazeede: {
         seo: {
            title: "Customer Support CRM Case Study - Mazeed | Pepper Cloud",
            keywords:
               "Finance CRM Case Study, WhatsApp CRM, CRM Case Studies, Dubai CRM",
            description:
               "How does Mazeed centralize support? They use Pepper Cloud CRM to route tickets via round-robin, manage WhatsApp groups in one place, and control staff data permissions.",
         },
         title: titles["mazeede"],
         description:
            "Mazeed is a Dubai-based financial services company that provides investment and savings solutions to its customers. With a rapidly growing customer base across the UAE, Mazeed needed a centralised platform to manage communication and support efficiently.",
         heroBg: mazeedHero,
         alt: "Mazeed",
         name: names["mazeede"],
         location: "Dubai, UAE",
         industry: "Finance",
         website: "https://www.mazeed.com",
         challegeQuotation: (
            <strong>
               "We wanted only specific users to see conversations while keeping
               everything private and managed from one platform."
            </strong>
         ),
         challenges: [
            <div>
               <p style={{ margin: "0 0 8px" }}>
                  Mazeed's frustrations involved multiple teams, particularly
                  accountants and account managers, interacting and managing
                  internal workflows across different tools and channels. While
                  they needed a single platform to manage all communications and
                  ticketing, the biggest concern was privacy and access control:
               </p>
               <ul style={{ margin: 0, paddingLeft: "20px", }}>
                  <li className={classes.listItem}>
                     Only relevant users (e.g., accountants and account
                     managers) should be able to see specific conversations or
                     message threads.
                  </li>
                  <li className={classes.listItem}>
                     Communication was fragmented, making it harder to ensure
                     accountability, enforce privacy, and track resolution
                     performance.
                  </li>
                  <li className={classes.listItem}>
                     Without a unified solution, tracking ticket response times,
                     assignments, and SLA compliance was manual and inefficient.
                  </li>
               </ul>
            </div>,
         ],
         solutionHeader:
            "Pepper Cloud CRM helped Mazeed centralise its messaging, ticketing, and team collaboration, all within a single platform, with strict access controls and performance visibility. The solution enabled Mazeed to:",
         solutionQuotation: (
            <strong>
               "Pepper Cloud CRM gave us a single platform where we could manage
               all communications with customised access controls and track
               performance in real time."
            </strong>
         ),
         solutions: [
            <div style={{marginBottom:'14px'}}>
               <strong>Customisable access permissions with label access</strong>
               <p style={{ margin: "4px 0 4px" }}>
                  Mazeed used Label Access to assign fine-tuned visibility
                  controls. This allowed the company to:
               </p>
               <ul style={{ margin: 0, paddingLeft: "20px" }}>
                  <li className={classes.listItem}>
                     Define exactly which users can view specific conversations
                     or groups, ensuring accountants and account managers only
                     see what's relevant to them.
                  </li>
                  <li className={classes.listItem}>
                     Maintain strict team privacy while keeping collaboration
                     friction-free for authorised users.
                  </li>
               </ul>
            </div>,
            <div style={{marginBottom:'14px'}}>
               <strong>
                  Ticketing system with round-robin assignment and SLA tracking
               </strong>
               <p style={{ margin: "4px 0 4px" }}>
                  Mazeed replaced manual tracking and ad-hoc allocations with a
                  structured ticketing workflow:
               </p>
               <ul style={{ margin: 0, paddingLeft: "20px" }}>
                  <li className={classes.listItem}>
                     Tickets are automatically distributed among team members
                     using a round-robin assignment, helping balance workload.
                  </li>
                  <li className={classes.listItem}>
                     SLA tracking and resolution-time dashboards provided
                     leaders with clear visibility into performance and
                     responsiveness, ensuring service standards were met.
                  </li>
               </ul>
            </div>,
            <div style={{marginBottom:'14px'}}>
               <strong>Centralised Messaging &amp; WhatsApp Groups Within CRM</strong>
               <p style={{ margin: "4px 0 4px" }}>
                  Instead of juggling external messaging tools:
               </p>
               <ul style={{ margin: 0, paddingLeft: "20px" }}>
                  <li className={classes.listItem}>
                     Mazeed created and managed WhatsApp groups directly within
                     Pepper Cloud CRM, consolidating all client communications
                     in one place.
                  </li>
                  <li className={classes.listItem}>
                     This improved context retention, reduced message loss, and
                     ensured conversations were auditable and searchable.
                  </li>
               </ul>
            </div>,
         ],
         orderedSolutions: true,
         solutionFooter: "",
         featuresUsed: [
            {
               icon: feature1,
               title: "WhatsApp integration",
               link: "/whatsapp-crm/",
            },
            { icon: feature6, title: "Message management", link: "" },
            {
               icon: feature7,
               title: "Sales pipeline management",
               link: "/sales-pipeline-management-tool/",
            },
         ],
         similarSuccessStories: [
            successStories["eng-choon-enterprise"],
            successStories["the-supreme"],
            successStories["cuscapi"],
         ],
      },
   };

   const scrollAboutList = () => {
      if (
         document.querySelector("#scrollIndicator")?.getBoundingClientRect()
            .top === 100
      ) {
         let winScroll =
            document.body.scrollTop || document.documentElement.scrollTop;
         let height =
            document.documentElement.scrollHeight -
            document.documentElement.clientHeight;
         let scrolled = (winScroll / height) * 100;
         document.getElementById("scrollIndicator").style.height =
            scrolled * 10 + "px";
      } else if (
         document.querySelector("#scrollIndicator")?.getBoundingClientRect()
            .top > 100
      ) {
         document.getElementById("scrollIndicator").style.height = "100px";
      } else if (
         document.querySelector("#scrollIndicator")?.getBoundingClientRect()
            .top < 100
      ) {
         document.getElementById("scrollIndicator").style.height = "500px";
      }
   };
   useEffect(() => {
      window.addEventListener("scroll", scrollAboutList);
   }, []);

   if (!caseStudies[company]) {
      return <NotFoundPage />;
   }

   const caseStudy = caseStudies[company];

   return (
      <React.Fragment>
         <SEO
            description={caseStudy.seo.description}
            keywords={caseStudy.seo.keywords}
            pathname={successStories[company].link}
            title={caseStudy.seo.title}
         />

         {/* Hero */}
         <Box className={classes.heroSection}>
            <Box className="container">
               <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
                  <Box mb={3} display="flex" flexWrap="wrap" alignItems="center">
                     <span className={classes.locationTag}>{caseStudy.location}</span>
                     <span className={classes.industryTag}>{caseStudy.industry}</span>
                  </Box>
               </motion.div>

               <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.1 }}>
                  <HeaderTypography component="h1" className={classes.heroHeading} fontWeight={600} lineHeight={1.4} mb={0} mt={0}>
                     {caseStudy.title}
                  </HeaderTypography>
               </motion.div>

               <motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.25 }}>
                  <Box className={classes.heroCard} mt={5}>
                     <img alt={caseStudy.alt} src={caseStudy.heroBg} className={classes.heroCardBgImg} />
                     <Box className={classes.heroCardContent}>
                        <Box className={classes.heroCardPanel}>
                           <Box component="p" fontSize={14} lineHeight={1.8} color="rgba(255,255,255,0.85)" mt={0} mb={4}>
                              {caseStudy.description}
                           </Box>
                           <Box display="flex" flexDirection="column" style={{ gap: "12px" }}>
                              <Box component="p" fontSize={18} fontWeight={700} color="white" m={0}>
                                 Features used:
                              </Box>
                              {caseStudy.featuresUsed.map((feature, idx) => (
                                 <motion.div
                                    key={idx}
                                    initial={{ opacity: 0, x: 20 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.4, delay: 0.4 + idx * 0.1 }}
                                 >
                                    <Box display="flex" alignItems="center" style={{ gap: "12px" }}>
                                       <Box className={classes.featureIconCircle}>
                                          <img alt={feature.title} src={feature.icon} style={{ width: 44, height: 44 }} />
                                       </Box>
                                       <Box component="span" fontSize={16} color="white">{feature.title}</Box>
                                    </Box>
                                 </motion.div>
                              ))}
                           </Box>
                        </Box>
                     </Box>
                  </Box>
               </motion.div>
            </Box>
         </Box>

         {/* Main content */}
         <Box className="container">
            <Box alignItems="flex-start" component={Grid} container justify="center" textAlign="left" spacing={5}>

               {/* Desktop sidebar */}
               <Hidden smDown>
                  <Grid item xs={3} lg={3} sm={3} md={3} className={classes.aboutList} display="flex" flexDirection="row" justifyContent="space-between">
                     <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.5 }} viewport={{ once: false }} style={{ width: "100%" }}>
                        <Box>
                           <Box mb={4} >{caseStudy.name}</Box>
                           <div className={classes.sidebarMeta}>
                              <RoomOutlined className={classes.sidebarMetaIcon} />
                              <Box>
                                 <p className={classes.sidebarMetaLabel}>Location</p>
                                 <p className={classes.sidebarMetaValue}>{caseStudy.location}</p>
                              </Box>
                           </div>
                           <div className={classes.sidebarMeta}>
                              <BusinessOutlined className={classes.sidebarMetaIcon} />
                              <Box>
                                 <p className={classes.sidebarMetaLabel}>Industry</p>
                                 <p className={classes.sidebarMetaValue}>{caseStudy.industry}</p>
                              </Box>
                           </div>
                           <div className={classes.sidebarMeta}>
                              <LanguageOutlined className={classes.sidebarMetaIcon} />
                              <Box>
                                 <p className={classes.sidebarMetaLabel}>Website</p>
                                 <p className={classes.sidebarMetaValue}>
                                    <a href={caseStudy.website} target="_blank" rel="noreferrer">
                                       {caseStudy.website.replace(/^https?:\/\//, "")}
                                    </a>
                                 </p>
                              </Box>
                           </div>
                        </Box>
                     </motion.div>
                     <Box className={classes.aboutListIndicator} id="scrollIndicator" />
                  </Grid>
               </Hidden>

               {/* Content column */}
               <Grid item xs={12} sm={12} md={9} lg={9}>

                  {/* Mobile meta */}
                  <Hidden mdUp>
                     <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }} viewport={{ once: false }}>
                        <Box mb={3}>
                           <Box mb={2}>{caseStudy.name}</Box>
                           <div className={classes.sidebarMeta}>
                              <RoomOutlined className={classes.sidebarMetaIcon} />
                              <Box>
                                 <p className={classes.sidebarMetaLabel}>Location</p>
                                 <p className={classes.sidebarMetaValue}>{caseStudy.location}</p>
                              </Box>
                           </div>
                           <div className={classes.sidebarMeta}>
                              <BusinessOutlined className={classes.sidebarMetaIcon} />
                              <Box>
                                 <p className={classes.sidebarMetaLabel}>Industry</p>
                                 <p className={classes.sidebarMetaValue}>{caseStudy.industry}</p>
                              </Box>
                           </div>
                           <div className={classes.sidebarMeta}>
                              <LanguageOutlined className={classes.sidebarMetaIcon} />
                              <Box>
                                 <p className={classes.sidebarMetaLabel}>Website</p>
                                 <p className={classes.sidebarMetaValue}>
                                    <a href={caseStudy.website} target="_blank" rel="noreferrer">
                                       {caseStudy.website.replace(/^https?:\/\//, "")}
                                    </a>
                                 </p>
                              </Box>
                           </div>
                        </Box>
                     </motion.div>
                  </Hidden>

                  {/* Challenge */}
                  <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} viewport={{ once: false }}>
                     <Box component="h2" className={classes.sectionHeading} mt={0}>The challenge</Box>
                  </motion.div>
                  <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.1 }} viewport={{ once: false }}>
                     <Box component="p" className={classes.quotationBlock}>{caseStudy.challegeQuotation}</Box>
                  </motion.div>
                  {caseStudy.challenges.map((challenge, i) => (
                     <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay: i * 0.08 }} viewport={{ once: false}}>
                        <ParagraphTypography mb={2}>{challenge}</ParagraphTypography>
                     </motion.div>
                  ))}

                  {/* Solution */}
                  <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} viewport={{ once: false }}>
                     <Box component="h2" className={classes.sectionHeading} mt={4}>The solution</Box>
                  </motion.div>
                  <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.1 }} viewport={{ once: false }}>
                     <Box component="p" className={classes.quotationBlock}>{caseStudy.solutionQuotation}</Box>
                  </motion.div>
                  <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay: 0.15 }} viewport={{ once: false }}>
                     <ParagraphTypography mb={2}>{caseStudy.solutionHeader}</ParagraphTypography>
                     {React.createElement(
                        caseStudy.orderedSolutions ? "ol" : "ul",
                        { style: { paddingLeft: "24px", margin: "0", fontSize: "18px", fontWeight: 700 } },
                        caseStudy.solutions.map((solution, i) => (
                           <li className={classes.listItem} key={i}>
                              <ParagraphTypography m={0}>{solution}</ParagraphTypography>
                           </li>
                        ))
                     )}
                     <ParagraphTypography>{caseStudy.solutionFooter}</ParagraphTypography>
                  </motion.div>
               </Grid>
            </Box>
         </Box>

         {/* Similar stories */}
         <Box style={{ background: "radial-gradient(circle at 10% 100%, rgba(255, 163, 101, 0.30) 0%, transparent 30%), radial-gradient(circle at 50% 100%, rgba(158, 90, 213, 0.30) 0%, transparent 40%),radial-gradient(circle at 90% 100%, rgba(159, 211, 255, 0.6) 0%, transparent 35%), transparent" }} paddingBottom={8}>
            <Box className="container">
               <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} viewport={{ once: false }}>
                  <HeaderTypography component="p" className={classes.sectionTitle} overrideClassName mb={4} mt={0}>Similar success stories</HeaderTypography>
               </motion.div>
               <Grid container justify="center" spacing={4}>
                  {caseStudy.similarSuccessStories.map((story, idx) => (
                     <Grid item md={4} sm={4} xs={12} key={idx} style={{ display: "flex" }}>
                        <motion.div
                           style={{ width: "100%" }}
                           initial={{ opacity: 0, y: 30 }}
                           whileInView={{ opacity: 1, y: 0 }}
                           transition={{ duration: 0.5, delay: idx * 0.12 }}
                           viewport={{ once: false }}
                        >
                           <div className={classes.storyCard} style={{ width: "100%" }}>
                              <img src={story.heroBg} alt={story.title} className={classes.storyCardImg} />
                              <img src={story.nameImg} alt={story.nameAlt} className={classes.storyCardLogo} />
                              <ParagraphTypography m={0} fontSize={16}>{story.title}</ParagraphTypography>
                              <Link to={story.link} className={classes.readMoreLink}>Read more →</Link>
                           </div>
                        </motion.div>
                     </Grid>
                  ))}
               </Grid>
            </Box>
         </Box>

         {/* Footer CTA */}
         <section className={classes.commonPageFooterSection}>
            <div className="container">
               <div className="centerContainer">
                  <motion.h2
                     className="font-wix-medium font-56 font-white"
                     style={{ margin: 0 }}
                     initial={{ opacity: 0, y: 30 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.5 }}
                     viewport={{ once: false }}
                  >
                     Let’s build your sales success together!
                  </motion.h2>
                  <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.2 }} viewport={{ once: false }}>
                     <Link className="primaryButton font-20 font-wix-medium font-white" to="/contact/">
                        Get Started
                     </Link>
                  </motion.div>
               </div>
            </div>
         </section>
      </React.Fragment>
   );
};

export default Company;
